<template>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
    <template v-slot:activator="{ on }">
    <v-btn v-on="on" :loading="saving"
          small color="warning"
          class="text-none ml-2" @click="checkMainId()">
            {{ $t('displayTags.buttons.confirmng') }}
    </v-btn>
    </template>
      <v-card>
        <v-card-title class="headline">{{ $t('Comfirm NG') }}
           <v-spacer></v-spacer>
           <v-btn icon small @click="dialog = false">
           <v-icon>mdi-close</v-icon>
           </v-btn>
        </v-card-title>

        <v-card-text>
        Do you really want to Confirm NG?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="saving"
            color="primary"
            class="text-none"
            @click="btnUpdateOverAllResult"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      newSubLine: {},
      // assetId: 4,
      default: false,
      dialog: false,
      saving: false,
    };
  },
  props: {
    rework: {
      type: Object,
      required: true,
    },
    runningOrderList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...mapMutations('helper', ['setAlert']),
    ...mapMutations('reworkOperation',
      ['setReworkList',
        'setComponentList',
        'setSingleNgCodeConfig',
        'setDisableSave',
        'setRoadmapDetailsList',
        'setPartStatusList',
        'setSelectedReworkRoadmap',
      ]),
    ...mapActions('reworkOperation', ['updateOverAllResultPartStatus', 'updateOverAllResult', 'getReworkList', 'addRework']),
    checkMainId() {
      this.dialog = true;
    },
    async btnUpdateOverAllResult() {
      // console.log(this.rework);
      this.saving = true;
      if (this.runningOrderList.length === 0) {
        this.setAlert({
          show: true,
          type: 'error',
          message: 'No order running!',
        });
        this.saving = false;
        return;
      }
      const {
        customername,
        ordername,
        ordernumber,
        ordertype,
        productid,
        productname,
        producttypename,
      } = this.runningOrderList[0];
      const payloadRework = {
        customername,
        ordername,
        ordernumber,
        ordertype,
        productid,
        productname,
        producttypename,
        checkoutngcode: 5001,
        lineid: 1,
        sublineid: 'subline-294',
        substationid: 'substation-249',
        mainid: this.rework.enterManinId,
        substationresult: 2,
        assetid: 4,
      };
      const payloadPartstatus = {
        query: `?query=mainid=="${this.rework.enterManinId}"&pagesize=1`,
        payload: {
          overallresult: 2,
        },
      };
      // if (payloadPartstatus) {
      //   return;
      // }
      await this.addRework(payloadRework);
      await this.updateOverAllResultPartStatus(payloadPartstatus);
      await this.getReworkList('?query=overallresult!="1"');
      this.dialog = false;
      this.$emit('callback');
      this.rework = [];
      this.setDisableSave(false);
      this.setSingleNgCodeConfig([]);
      this.setComponentList([]);
      this.setRoadmapDetailsList([]);
      this.setPartStatusList([]);
      this.setSelectedReworkRoadmap(null);
      this.saving = false;
    },
  },
};
</script>
